module.exports = __webpack_public_path__ + "img/81.2.TN.6138c201.png";